import { HttpError } from "@refinedev/core";
import { useTable } from "@refinedev/react-table";

import { DataTable } from "@/components/refine-ui/data-table/data-table";
import { DataTableActionBar } from "@/components/refine-ui/data-table/data-table-action-bar";
import { ListView } from "@/components/refine-ui/views/list-view";
import { usePeopleColumns } from "@/pages/people/hooks/use-columns";
import { IPersonData } from "@/types/person";

export const PeopleList = () => {
  const columns = usePeopleColumns();

  const table = useTable<IPersonData, HttpError>({
    columns,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      columnVisibility: { id: false },
      columnPinning: { right: ["actions"] },
    },
    refineCoreProps: {
      meta: {
        defaultQueryBy: "name",
        // Populate the knownForDepartment faceted filter options up front.
        facetBy: ["knownForDepartment"],
      },
      sorters: { initial: [{ field: "name", order: "asc" }] },
      pagination: { pageSize: 25 },
    },
  });

  return (
    <ListView>
      <DataTableActionBar resource="people" table={table} />
      <DataTable table={table} />
    </ListView>
  );
};
